import scriptjs from 'scriptjs';
import constants from '../../../qti/Constants';
import stringUtils from '../../../qti/utils/StringUtils';
import sessionReader from '../../../store/readHelpers/SessionReader';

let mathJaxInitialized = false;
let mathJaxInitInProgress = false;

function configureMathJax() {
    window.MathJax = {
        tex: {
            inlineMath: [['\\(', '\\)']],
            displayMath: [],
        },
        options: {
            enableMenu: false,
        },
    };
}

async function getMathJaxInstanceAndDoInitTypeset() {
    if (window.MathJax) {
        return window.MathJax;
    }
    mathJaxInitInProgress = true;

    return new Promise((resolve, reject) => {
        let mathJaxUrl;
        if (sessionReader?.isOfflineMode()) {
            mathJaxUrl = `${constants.staticLibPathsOffline.MATHJAX3}tex-chtml.js`;
        } else if (sessionReader?.isViewMediaPrintOrPdf()) {
            mathJaxUrl = `${constants.staticLibPaths.MATHJAX3}tex-svg.js`;
        } else {
            mathJaxUrl = `${constants.staticLibPaths.MATHJAX3}tex-chtml.js`;
        }

        configureMathJax();
        window.MathJax.startup = {
            ready: async () => {
                try {
                    await window.MathJax.startup.defaultReady();
                    console.log('MathJax initial typesetting complete');
                    resolve(window.MathJax);
                    mathJaxInitInProgress = false;
                } catch (e) {
                    reject(e);
                }
            },
        };
        scriptjs(mathJaxUrl, () => {
            if (!window.MathJax) {
                reject('MathJax 3 could not be loaded!');
            }
        });
    });
}

export function removeStartEndSequence(latexString) {
    if (typeof latexString !== 'string') {
        return latexString;
    }
    return latexString.replace(/\\\(|\\\)/g, '');
}

/**
 * When preloading, render the math elements manually and append them to the preload container.
 * If doing regular render (as when displaying then and replacing), the math elements on the page you are viewing
 * are also affected by blinking shortly as the page is scanned.
 * @param wrapperElement
 */
function preloadMathOnPage(wrapperElement) {
    Array.from(wrapperElement.getElementsByClassName('math-tex')).forEach((element) => {
        const textToPreload = removeStartEndSequence(stringUtils.unescapeXML(element.innerHTML));
        try {
            const html = window.MathJax.tex2chtml(textToPreload, { display: false });
            wrapperElement.appendChild(html);
        } catch (e) {
            console.warn('Error when preloading Mathjax', e);
        }
    });
    // Adding css needed to display the current math elements. This triggers loading of fonts needed for the new expressions
    document.head.appendChild(window.MathJax.chtmlStylesheet());
}

const MathJax3Display = {
    async showMathJax3(wrapperElement) {
        if (mathJaxInitInProgress || !wrapperElement || wrapperElement.getElementsByClassName('math-tex').length === 0) {
            return;
        }
        const isPreload = wrapperElement.getAttribute('id')?.includes('preload');
        if (mathJaxInitialized && isPreload) {
            preloadMathOnPage(wrapperElement);
            return;
        }
        if (!mathJaxInitialized) {
            try {
                await getMathJaxInstanceAndDoInitTypeset();
                mathJaxInitialized = true;
                return;
            } catch (e) {
                console.error('Unable to load Mathjax 3', e);
                return;
            }
        }
        await window.MathJax.typesetPromise();
    },
};

export default MathJax3Display;
